import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
  name: 'infoLabel',
})
export class InfoLabelPipe implements PipeTransform {
  transform(value: string): string {
    return value === null || value === undefined || /^\s*$/.test(value) ? '-' : value
  }
}
